// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__3lrD4","footerLinksContainer":"Footer_footerLinksContainer__3RwkD","copyrightPart":"Footer_copyrightPart__2dkjx"};